export const EMAIL_REGX = /^[-!#$%&'*+/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
export const PHONE_REGX = /^([0-9 \\()\\]{4})\s([7-9]{1})?(\d{4})-(\d{4})$/
export const ONLY_NUMBERS_REGX = /^\d+$/
export const NO_NUMBER_REGX = /^[Ss]{1}[/]{1}[Nn]{1}$/
export const AT_LEAST_LOWERCASE = /^(?=.*[a-z])/
export const AT_LEAST_UPPERCASE = /^(?=.*[A-Z])/
export const AT_LEAST_NUMBER = /^(?=.*[0-9])/
export const AT_LEAST_SPECIAL_CHAR = /^(?=.*[$*&@#!%;:.])/
export const CPF_REGEX = /^(\d{3}).(\d{3}).(\d{3})-(\d{2})$/
export const CNPJ_REGEX = /^(\d{2}).(\d{3}).(\d{3})\/(\d{4})-(\d{2})$/
export const CR_DOCUMENT = /^(\w{3,5})-(\d{4,7})$/
export const CEP_REGX = /^(\d{5})-(\d{3})$/
export const SCHEDULE_REGX = /^(2[0-3])|([0-1][0-9]):([0-5][0-9])$/
export const DATE_REGX = /^(\d{2})\/(\d{2})\/(\d{4})$/
